import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { SessionDisplayPipe } from '../pipes/session-display.pipe';
import { DiscountPricePipe } from '../pipes/discount-price.pipe';
import { ShareService } from '../share.service';
@Component({
  selector: 'app-purchase-promotion-result',
  templateUrl: './purchase-promotion-result.page.html',
  styleUrls: ['./purchase-promotion-result.page.scss'],
  providers: [ SessionDisplayPipe, DiscountPricePipe]
})
export class PurchasePromotionResultPage implements OnInit {
  promotionDetails: any = { };
  private currentUser: any = null;
  public emailId: string;
  public emailBody: string;
  public facebookShareUrl: string;
  public twitterShareUrl: string;
  constructor(private route: ActivatedRoute,
              private router: Router,
              public shareService: ShareService,
              private sessiondisplaypipe: SessionDisplayPipe,
              private discountpricepipe: DiscountPricePipe,
            ) {
          this.route.queryParams.subscribe(params => {
            if (this.router.getCurrentNavigation().extras.state) {
              this.promotionDetails = this.router.getCurrentNavigation().extras.state.promo;
              this.createShareMessage();
              this.currentUser = JSON.parse(localStorage.getItem('pToken'));
              if (this.currentUser) {
                  this.emailId = this.currentUser.user.email;
              }
            }
          });
  }

  ngOnInit() {
  }

  showListings() {
    this.router.navigate(['/search/promotions']);
  }

  shareFacebook() {
    const promotionUrl = window.location.protocol + '//' + window.location.host + '/#/promotion/' + this.promotionDetails.id;
    this.shareService.shareToFacebook(promotionUrl);
  }

  createShareMessage() {
    if (this.promotionDetails) {
      const promotionUrl = window.location.protocol + '//' + window.location.host + '/#/promotion/' + this.promotionDetails.id;
      const nl = encodeURI('\n\r');
      const emailMessageBody = 'Hi' +
      nl + nl + 'Check out this cool activity on Promoga!' +
      nl + nl + this.sessiondisplaypipe.transform(this.promotionDetails.session_value) +
      ' of ' + this.promotionDetails.class.title + ' ' + this.discountpricepipe.transform(this.promotionDetails) +
      nl + nl + this.shareService.shareToEmail(promotionUrl) +
      nl + nl + 'Cheers,' ;
      this.emailBody = emailMessageBody;
      this.twitterShareUrl = this.shareService.shareToTwitter(promotionUrl);
    }
  }

}
